!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this._fixedImage = null, this._observer = null;
    }
    connectedCallback() {
      this._fixedImage = this.querySelector(".hero__fixed-img"), this._fixedImage && (this._observer = new IntersectionObserver(([e]) => this._onIntersect(e), {
        threshold: [ 0, .05 ]
      }), this._observer.observe(this));
    }
    disconnectedCallback() {
      this._observer?.disconnect();
    }
    _onIntersect(e) {
      const t = e.intersectionRatio <= .05 && e.boundingClientRect.top < 0;
      this._fixedImage.style.opacity = t ? "1" : "0", this._fixedImage.style.pointerEvents = t ? "" : "none";
    }
  }
  customElements.define("hero-element", e);
}();